import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { MatTable } from '@angular/material/table';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { EnergyProvidersModalComponent } from '../../admin-utility/energy-providers-modal/energy-providers-modal.component';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { EnergyProvidersTduRatesModalComponent } from '../../admin-utility/energy-providers-tdu-rates-modal/energy-providers-tdu-rates-modal.component';

@Component({
  selector: 'app-hg-energy-providers-tdu-rates',
  templateUrl: './hg-energy-providers-tdu-rates.component.html',
  styleUrls: ['./hg-energy-providers-tdu-rates.component.css'],
})
export class HgEnergyProvidersTduRatesComponent implements OnInit {
  @ViewChild('tduPaginator', { read: MatPaginator }) tduPaginator: MatPaginator;

  tduDisplayedColumns: string[] = [
    'action',
    'Abbreviation',
    'Code',
    'IstaId',
    'MoveInFee',
    'PriorityMoveInFee',
    'SwitchFee',
    'TypeOfTDU',
    'TDU_Charges_Month',
    'TDU_Charges_Kwh',
    // 'Daily_Charge',
    // 'Energy_Price',
    // 'Five_Hundred',
    // 'Thousand',
    // 'Two_Thousand',
  ];
  tduData: MatTableDataSource<tduBlock>;
  tduBlocks: tduBlock[];
  selected: string;
  // tduArr = [
  //   { value: 'AEPC', text: 'AEPC' },
  //   { value: 'AEPN', text: 'AEPN' },
  //   { value: 'CNP', text: 'CNP' },
  //   { value: 'NUEC', text: 'NUEC' },
  //   { value: 'ONC', text: 'ONC' },
  //   { value: 'SHAR', text: 'SHAR' },
  //   { value: 'TNMP', text: 'TNMP' },
  // ];
  constructor(
    private http: HttpClient,
    private router: Router,
    private residentialService: ResidentialService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.HgResEnergyProviderstduRates();
  }
  HgResEnergyProviderstduRates() {
    this.residentialService
      .HgResEnergyProviderstduRates()
      .subscribe((response: any) => {
        // console.log(response);
        this.tduBlocks = response;
        this.tduData = new MatTableDataSource<tduBlock>(this.tduBlocks);
        this.tduData.paginator = this.tduPaginator;
        // this.dataSource.paginator = this.paginator;
      });
  }
  createTDURatesDialog(action, itemData?): void {
    const dialogRef = this.dialog.open(EnergyProvidersTduRatesModalComponent, {
      width: '1000px',
      data: { pageValue: this.tduBlocks, action, itemData },

      // data: {name: this.nacdme, animal: this.animal},
    });

    dialogRef.afterClosed().subscribe((result) => {
      // console.log('The dialog was closed');
      // this.animal = result;
      this.HgResEnergyProviderstduRates();
    });
  }

  checkForWholeOrDecimal(number) {
    if (number == Math.floor(number)) {
      return `${number}.00`;
    } else {
      const newValue = number.toString();
      const newString =
        newValue.substring(newValue.indexOf('.') + 1).length >= 2
          ? newValue.substring(newValue.indexOf('.') + 1)
          : `${newValue.substring(newValue.indexOf('.') + 1)}0`;
      return `${newValue.substring(0, newValue.indexOf('.'))}.${newString}`;
    }
  }
  onChageProvider(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tduData.filter = filterValue.trim().toLowerCase();
  }
}
export interface tduBlock {
  Abbreviation: string;
  Code: string;
  IstaId: number;
  MoveInFee: number;
  PriorityMoveInFee: number;
  SwitchFee: number;
  TypeOfTDU: string;
  TDU_Charges_Month: number;
  TDU_Charges_Kwh: string;
  
  // Daily_Charge: string;
  // Energy_Price: string;
  // Five_Hundred: number;
  // Thousand: number;
  // Two_Thousand: number;
}
